import { render } from "./CarrouselContent.vue?vue&type=template&id=3218aee7&scoped=true"
import script from "./CarrouselContent.vue?vue&type=script&lang=js"
export * from "./CarrouselContent.vue?vue&type=script&lang=js"

import "./CarrouselContent.vue?vue&type=style&index=0&id=3218aee7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3218aee7"]])

export default __exports__